module.exports = __webpack_public_path__ + "img/banner-17.aaebb106.jpg";